import React, { Component } from 'react';
import Clients from './Clients';

class ElevatorPage extends Component {
	render () {
		return <Clients type="elevator" />
	}
}

export default ElevatorPage;



// WEBPACK FOOTER //
// ./containers/ElevatorPage.js